import { isEmbeddedInLobby } from '@/logic/embedded-mode';
import { useStore } from '@/store/useStore';
import { isSameOriginMountPath } from '@/utilities/helpers/same-origin-path.ts';

/** Lobby embed and native wrappers share origin with a second Account UM instance. */
export const shouldEnforceFabricAuthCookies = (): boolean => {
  if (isEmbeddedInLobby()) {
    return true;
  }

  if (
    typeof window !== 'undefined' &&
    isSameOriginMountPath(window.location.pathname)
  ) {
    return true;
  }

  const { isAndroid, isXsell } = useStore.getState().runtime.wrapperType;
  return isAndroid || isXsell;
};
